import {useState} from 'react';
import { Icon } from '@iconify/react';

const Chart = (props) => {

  var srcList = props.srcList;
  // var imgSet = props.imgSet;
  var item = props.item;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var mvtIcon = props.mvtIcon;
  var buttonsOutside = props.buttonsOutside;

  const [screenNos, setScreenNos] = useState(item);

  var thisImg = srcList[screenNos];
  if (thisImg.indexOf('ipfs://') === 0){
    thisImg = 'https://ipfs.io/ipfs/' + thisImg.substr(7);
  }

  function clickClose(e){
    popUps.pop();
    setPopUps([...popUps]);
  }

  function clickLeft(e){
    if (screenNos > 0){
      setScreenNos(screenNos-1);
    }else{
      setScreenNos(srcList.length - 1);
    }
  }

  function clickRight(e){
    if (screenNos < srcList.length - 1){
      setScreenNos(screenNos + 1);
    }else{
      setScreenNos(0);
    }
  }

   return <div className='container text-center' style={{marginTop:'10%', marginBottom:'5%', width:'80%', height:'80%', borderRadius:'15px'}}>
                <div style = {{color: 'white', display:'inline', position:'relative'}}>
                    <img style = {{maxHeight:'80%', maxWidth: '80%', border: '1px solid white'}} src = {thisImg} alt='' />
                    <Icon onClick={clickClose} className='growButton' style={{right:0}} color='white'  height = "30" icon="eva:close-fill" />
                    <div className='growButton' style={{left:(buttonsOutside ? '-50px' : 0), top:'50%'}} onClick={clickLeft}>
                        <Icon height = "30" icon={mvtIcon} />
                    </div>
                    <div className='growButton' style={{right:(buttonsOutside ? '-50px' : 0), top:'50%'}} onClick={clickRight}>
                        <Icon height = "30" icon={mvtIcon.split('left').join('right')} />
                    </div>
                    
                </div>
            </div>


};

export default Chart;